import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed';

export const Yaleo = {
  Helmet: lazyNamed(() => import('./components/Helmet'), 'Helmet'),
  Websites: {
    Layout: lazy(() => import('./containers/Websites/components/WebsitesLayout')),
    CrawlerConfig: lazy(() => import('./containers/Websites/containers/CrawlerConfig')),
    Websites: lazyNamed(() => import('./containers/Websites/containers/WebsitesList'), 'WebsitesList'),
    WebsitesRedirector: lazyNamed(() => import('./containers/Websites/components/WebsitesRedirector'), 'WebsitesRedirector'),
  },
  Placements: {
    PlacementList: lazy(() => import('./containers/PlacementList')),
    PlacementManage: lazy(() => import('./containers/PlacementManage')),
  },
  PlacementsNew: {
    PlacementList: lazyNamed(() => import('./containers/PlacementListV2'), 'PlacementListV2'),
    PlacementManage: lazyNamed(() => import('./containers/PlacementManageV2'), 'PlacementManageV2'),
  },
  BTAFeed: {
    Websites: lazyNamed(() => import('./containers/BTAFeed/pages/Websites'), 'Websites'),
    LegacyForm: lazyNamed(() => import('./containers/BTAFeed/pages/BTAFeedForm'), 'BTAFeedForm'),
    Form: lazyNamed(() => import('./scenes/BtaFeed/BtaFeedForm'), 'BtaFeedForm'),
  },
  /**
   * The whole section is hidden from navigation until further notice: https://gitlab.audienzz.ch/audienzz/audienzz/-/work_items/21588
   */
  Collect: {
    CrawlerConfigPage: lazy(() => import('./containers/Collect/containers/CrawlerConfigPage')),
    CrawlerEditConfigPage: lazy(() => import('./containers/Collect/containers/CrawlerConfigPage/CrawlerEditConfigPage')),
    CrawlerPathEditPage: lazy(() => import('./containers/Collect/containers/CrawlerConfigPage/CrawlerPathConfigEdit')),
    CrawlerConfigsListPage: lazy(() => import('./containers/Collect/containers/CrawlerConfigsListPage')),
  },
  AlgorithmsConfig: lazyNamed(() => import('./containers/AlgorithmsConfig'), 'AlgorithmsConfig'),
};
